import { useMutation } from '@tanstack/react-query';

import { useAppDispatch } from 'store';

import { startTimer } from 'modules/blok-test';
import { $apiV2, errorHandler } from 'modules/global';

import { IAutoTest, IQuestion } from '../model';
import { IQuestionResult, setAllAnswers, setTestData } from '../store';

const extractAnswersFromTestData = (data: IAutoTest): Record<number, IQuestionResult> => {
  const result: Record<number, IQuestionResult> = {};

  const questions = data?.tests?.[0]?.questions || [];

  questions.forEach((question: IQuestion) => {
    if (question?.is_checked !== null && question?.is_right !== null) {
      result[question?.id] = {
        selectedAnswer: question?.is_checked,
        isRight: question?.is_right,
        rightAnswer: question?.is_true
      };
    }
  });

  return result;
};

export const useAutoTestCreate = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async (testId?: number) => {
      const { data } = await $apiV2.post('/auto-test/create', {
        test_id: testId
      });

      return data;
    },
    onSuccess: data => {
      dispatch(setTestData(data?.data));
      dispatch(startTimer());

      const prefilledAnswers = extractAnswersFromTestData(data?.data);

      dispatch(setAllAnswers(prefilledAnswers));
    },
    onError: errorHandler()
  });
};
